/**
 * Summary
 * This component is responsible for displaying the chronicle's controls.
 * The controls will be IconButtons and a Toggle (for authors).
 */

import React from "react";
// import { useSelector } from 'react-redux';
import { useContextMenu } from "react-contexify";
import { useApp, useModal } from "../_contexts";

import { IconButton, Toggle } from "../_components";

export function ChronicleControls(props) {
  const { openModal } = useModal();
  // const [helpModalOpen, setHelpModalOpen] = useState(false);

  // const { data } = useSelector((state) => state.chronicle);
  const { editMode, setEditMode, user: currentUser } = useApp();
  const toggleEditMode = () => {
    setEditMode(!editMode);
  };
  const { show } = useContextMenu({
    id: "chronos-chronicle-add-menu",
  });

  let author = false;
  if (currentUser && currentUser !== null && currentUser.isEditor) {
    author = true;
  }

  return (
    <div className="chronos-chronicle-controls">
      {/* Global ADD Menu */}
      {editMode && author && (
        <IconButton
          className="chronos-chronicle-add-button"
          icon="fas fa-plus fa-2x"
          color="success"
          iconColor="white"
          onClick={show}
          style={{ boxShadow: "rgba(0,0,0,0.65) 0px 1px 5px 0px" }}
        />
      )}
      {/* Viewer Controls */}
      {!editMode && (
        <IconButton
          icon="fas fa-question-circle fa-lg fa-fw"
          // bgcolor="transparent"
          iconOnly
          iconColor="white"
          click={() => openModal("help")}
          rounded
          className="chronos-help-btn"
          style={{ boxShadow: "rgba(0,0,0,0.65) 0px 1px 5px 0px" }}
        />
      )}

      {/* Editor/Author Toggle */}
      {author && (
        <Toggle
          id="editorMode"
          name="editorMode"
          checked={editMode}
          onChange={toggleEditMode}
          onText="Editor"
          onColor="#bfb49d"
          offText="Viewer"
          offColor="#766c57"
          style={{ boxShadow: "rgba(0,0,0,0.65) 0px 1px 5px 0px" }}
        />
      )}
    </div>
  );
}
